import { render, staticRenderFns } from "./_manage-sso-configuration.vue?vue&type=template&id=d04f5e10&scoped=true"
import script from "./_manage-sso-configuration.vue?vue&type=script&lang=js"
export * from "./_manage-sso-configuration.vue?vue&type=script&lang=js"
import style0 from "./_manage-sso-configuration.vue?vue&type=style&index=0&id=d04f5e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04f5e10",
  null
  
)

export default component.exports